// de_pms_live_board.ts
// Tłumaczenia dla PMS.LiveBoard.Dashboard.tsx

export const dePmsLiveBoard = {

  title:         "Live Board",
  managerView:   "Manager-Dashboard",
  newReservation:"Neue Reservierung",
  today:         "Heute",

  // ── Kafelki główne ───────────────────────────────────────────────────────
  tiles: {
    occupancy:   "Auslastung",
    arrivals:    "Anreisen",
    departures:  "Abreisen",
    inHouse:     "In-house",
    readyRooms:  "Gotowe pokoje",
    openIssues:  "Offene Probleme",
  },

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    housekeeping: "Housekeeping",
    frontDesk:    "Rezeption",
    billing:      "Abrechnung",
  },

  // ── Przyciski operacji ───────────────────────────────────────────────────
  actions: {
    checkIn:        "Einchecken",
    checkInNow:     "Jetzt einchecken",
    checkOut:       "Auschecken",
    confirmCheckIn: "Check-in bestaetigen",
    confirmCheckOut:"Check-out bestaetigen",
    confirmMove:    "Zimmerwechsel bestaetigen",
    earlyCheckIn:   "Frueher Check-in",
    lateCheckOut:   "Spaeter Check-out",
    roomMove:       "Zimmerwechsel",
    walkIn:         "Walk-in",
    approve:        "Genehmigen",
    addNote:        "Notiz hinzufuegen",
    saveNote:       "Notiz speichern",
  },

  // ── Notatka ──────────────────────────────────────────────────────────────
  noteQuestion: "Was sollte das Team wissen?",

  // ── Statusy i wyniki akcji ───────────────────────────────────────────────
  messages: {
    checkInSuccessful:       "Check-in erfolgreich abgeschlossen",
    checkInFailed:           "Check-in fehlgeschlagen",
    checkOutSuccessful:      "Check-out erfolgreich abgeschlossen",
    checkOutFailed:          "Check-out fehlgeschlagen",
    checkInNotPossible:      "Check-in vor dem Anreisedatum nicht moeglich",
    lateCheckoutFailed:      "Spaeter Check-out fehlgeschlagen",
    lateCheckoutUntil:       "Spaeter Check-out bis ",
    roomMoveCompleted:       "Zimmerwechsel abgeschlossen",
    roomMoveFailed:          "Zimmerwechsel fehlgeschlagen",
    roomMovePrefix:          "Wechsel: ",
    noteAdded:               "Notiz hinzugefuegt",
    failedToAddNote:         "Notiz konnte nicht hinzugefuegt werden",
    alertDismissed:          "Alarm verworfen",
    approved:                "Genehmigt",
    approvedFromLiveBoard:   "Vom Live Board genehmigt",
    paymentPosted:           "Zahlung gebucht",
    chargePosted:            "Gebuehr gebucht",
    housekeepingTaskCreated: "Housekeeping-Aufgabe erstellt",
    incidentResolved:        "Vorfall geloest",
    reservationCreated:      "Reservierung erstellt",
    walkInCheckedIn:         "Walk-in eingecheckt: ",
    walkInFailed:            "Walk-in fehlgeschlagen",
    walkInReservationCreated:"Walk-in-Reservierung erstellt",
    roomStatusUpdated:       "Zimmerstatus aktualisiert",
    failedToUpdateRoom:      "Zimmer konnte nicht aktualisiert werden",
    failedToUpdateRoomStatus:"Zimmerstatus konnte nicht aktualisiert werden",
    failedToUpdateIncident:  "Vorfall konnte nicht aktualisiert werden",
    failedToAssign:          "Zuweisung fehlgeschlagen",
    noPropertySelected:      "Kein Objekt ausgewaehlt",
    noPendingArrivals:       "Keine ausstehenden Anreisen",
    noPendingDepartures:     "Keine ausstehenden Abreisen",
    needsAction:             "Erfordert Aktion",
  },

  // ── Etykiety tabelki/kart ─────────────────────────────────────────────────
  labels: {
    floor:    "Etage ",
    room:     "Zimmer ",
    guest:    "Gast",
    guestsNow:"Gaeste jetzt",
    fullName: "Vollstaendiger Name",
    standard: "Standard",
    nights:   "Naechte",
  },

} as const;

export default dePmsLiveBoard;
